import { Classes, Colors } from "@blueprintjs/core";

import { Box, Flex } from "@/components/layout/flexbox";
import { Media } from "@/components/layout/Media";
import { BackLink } from "@/components/pieces/BackLink";
import { Avatar } from "@/components/pieces/users/Avatar";
import {
  DirectMessageUser,
  ReviewChatUser,
  WorkspaceMeetingUser,
} from "@/types/users";

type ChatUser = (DirectMessageUser | WorkspaceMeetingUser | ReviewChatUser) & {
  isAgent?: boolean;
  email?: string;
};

interface ChatHeaderProps {
  user?: ChatUser | null;
  channelName?: React.ReactNode;
  loading: boolean;
  backLinkTo?: string;
}

export function ChatHeader({
  user,
  channelName,
  loading,
  backLinkTo,
}: ChatHeaderProps) {
  if (loading) {
    return (
      <>
        <Flex alignItems="center">
          <Box
            style={{ borderRadius: "100%" }}
            width={34}
            height={34}
            className={Classes.SKELETON}
          />
          <Box ml={2} className={Classes.SKELETON} width={100} height={34} />
        </Flex>
      </>
    );
  }

  return (
    <>
      {user?.isAgent ? (
        <Flex alignItems="center">
          <Media at="xs">
            <Box ml={-3}>
              <BackLink to={backLinkTo} py={2} px={3} />
            </Box>
          </Media>
          <Avatar user={user} />
          <Box ml={2}>{user.name || user.email}</Box>
        </Flex>
      ) : null}
      <Flex alignItems="center">
        {user?.isAgent ? null : (
          <Media at="xs">
            <Box ml={-3}>
              <BackLink to={backLinkTo} py={2} px={3} />
            </Box>
          </Media>
        )}
        <Box style={{ color: user?.isAgent ? Colors.GRAY3 : undefined }}>
          {channelName}
        </Box>
      </Flex>
    </>
  );
}
